import React from 'react';
import { observer } from "mobx-react-lite";
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Slider, SliderTrack, SliderThumb } from '../../../editor/Slider';
import { ElementGroup, ElementLabel } from './BaseElements';
const SliderContainer = styled.div.withConfig({
  displayName: "PercentageSliderActionDetail__SliderContainer",
  componentId: "sc-1386vly-0"
})(["display:flex;flex-direction:row;margin:8px;align-items:center;justify-content:center;flex-grow:1;"]);
const SliderLabel = styled.div.withConfig({
  displayName: "PercentageSliderActionDetail__SliderLabel",
  componentId: "sc-1386vly-1"
})(["margin:0px 4px;"]);
export const PercentageSliderActionDetail = observer(({
  keyName,
  keyLabelLeft,
  keyLabelRight,
  value,
  valueSetter,
  min,
  max,
  step
}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(ElementGroup, null, /*#__PURE__*/React.createElement(ElementLabel, null, t(keyName) + ": " + Math.floor(value * 100) + "%"), /*#__PURE__*/React.createElement(SliderContainer, null, keyLabelLeft && /*#__PURE__*/React.createElement(SliderLabel, null, t(keyLabelLeft)), /*#__PURE__*/React.createElement(Slider, {
    value: value,
    min: min,
    max: max,
    step: step,
    renderTrack: SliderTrack,
    renderThumb: SliderThumb,
    onChange: valueSetter
  }), keyLabelRight && /*#__PURE__*/React.createElement(SliderLabel, null, t(keyLabelRight))));
});